/* tslint:disable */
export var icon = "\n<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 11v-1h8.043L9.25 6.25 10 5.5l5 5.043-5 4.957-.75-.75L13.128 11z\" fill-rule=\"nonzero\"/></svg>\n";
//# sourceMappingURL=arrow-next.svg.js.map